import gql from 'graphql-tag'
import { PRODUCT_REFERENCE_FRAGMENT } from './fragments.graphql'

export const GET_PRODUCTS_FOR_MANUFACTURER = gql`
  ${PRODUCT_REFERENCE_FRAGMENT}

  fragment NavigationTreeItem on CategoryNavigationTreeItem {
    categoryDisplayName
    categoryPathSlug
    hits
  }

  query GetProductsForManufacturer(
    $sortBy: SortBy!
    $page: Int!
    $pageSize: Int!
    $selectedFacets: [FacetParameterInput!]
    $selectedCategoryPath: String
    $manufacturerName: String
  ) {
    manufacturerProductSearch(
      sortBy: $sortBy
      page: $page
      pageSize: $pageSize
      facets: $selectedFacets
      selectedCategoryPath: $selectedCategoryPath
      manufacturerName: $manufacturerName
    ) {
      facets {
        name
        type
        displayName
        displayEnglishName
        facetOpened
        nameInUrl
        isTranslated
        unitText
        values {
          displayName
          name
          hits
          min
          max
        }
      }
      productReferences {
        ...ProductReference
      }
      navigationTree {
        ...NavigationTreeItem
        children {
          ...NavigationTreeItem
          children {
            ...NavigationTreeItem
          }
        }
      }
      productHits
    }
  }
`
